module.exports = __webpack_public_path__ + "1c7976fe22ab3bfdecc61f7cbe171ace.png";